import { Box, Typography, useTheme } from '@mui/material';

interface AttributeHeaderProps {
  name: string;
  required?: boolean;
}

export const AttributeHeader = ({ name, required }: AttributeHeaderProps) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', gap: theme.spacing(1) }}>
      <Typography variant="body1" sx={{ textTransform: 'capitalize', fontWeight: '500' }}>
        {name}
      </Typography>

      {required && (
        <Typography variant="body2" sx={{ color: theme.palette.error.main, fontWeight: 700 }}>
          *
        </Typography>
      )}
    </Box>
  );
};
